import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion, EASE, DUR } from "../utils/motion";

gsap.registerPlugin(ScrollTrigger);

const ProjectsHeader = () => {
    const sectionRef  = useRef(null);
    const titleRef    = useRef(null);
    const subtitleRef = useRef(null);
    const lineRef     = useRef(null);

    useEffect(() => {
        if (prefersReducedMotion()) return;

        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: sectionRef.current,
                    start: "top 80%",
                    toggleActions: "play none none reset",
                },
                defaults: { ease: EASE.strong },
            });

            // Title — blur to sharp, rises in
            tl.from(titleRef.current, {
                opacity: 0,
                y: 56,
                filter: "blur(10px)",
                duration: DUR.cinematic,
                clearProps: "filter",
            })
            // Subtitle follows
            .from(subtitleRef.current, {
                opacity: 0,
                y: 36,
                filter: "blur(5px)",
                duration: 1.1,
                ease: EASE.standard,
                clearProps: "filter",
            }, "-=0.7")
            // Accent line draws in under the title
            .from(lineRef.current, {
                scaleX: 0,
                duration: 0.8,
                ease: EASE.standard,
                transformOrigin: "left center",
            }, "-=0.9");
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section className="projects-section" id="projects" ref={sectionRef}>
            <div className="projects-header">
                <h2 className="projects-title" ref={titleRef}>
                    Projects
                </h2>
                {/* Decorative accent line — drawn in via GSAP */}
                <span className="projects-accent-line" ref={lineRef} aria-hidden="true" />
                <p className="projects-subtitle" ref={subtitleRef}>
                    A showcase of my work across different domains
                </p>
            </div>
        </section>
    );
};

export default ProjectsHeader;
